"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.LoadLocalizationNamespace = exports.useLocalization = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _jsxRuntime = require("react/jsx-runtime");

var _i18next = _interopRequireDefault(require("i18next"));

var React = _interopRequireWildcard(require("react"));

var _overrideSettings = require("./override-settings/overrideSettings");

/**
 * Get a translation function and namespace resource-is-loaded boolean flag.
 *
 * ```ts
 * // Get both the t() function and loaded flag.
 * const [t, loaded] = useLocalization('MyNamespace');
 *
 * // Get just the t() function.
 * const [t] = useLocalization('MyNamespace');
 *
 * // Get just the resource loaded flag.
 * const [, loaded] = useLocalization('MyNamespace');
 *
 * // Use multiple namespaces. The loaded flag will be updated when all
 * // namespaces have been loaded.
 * const [t, loaded] = useLocalization(['NamespaceA', 'NamespaceB']);
 * ```
 */
var useLocalization = function useLocalization(namespace) {
  if (typeof namespace === 'string') {
    namespace = [namespace];
  }

  var _useState = (0, React.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var t = (0, React.useRef)(_i18next.default.getFixedT(null, namespace));
  (0, React.useEffect)(function () {
    _i18next.default.loadNamespaces(namespace, function (err) {
      if (err) {
        console.warn(err);
        var telemetryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');
        telemetryEmitter === null || telemetryEmitter === void 0 ? void 0 : telemetryEmitter.error('Localization Load Failure', {
          error: "".concat(err)
        });
      }

      t.current = _i18next.default.getFixedT(null, namespace);
      setLoaded(true);
    });
  }, namespace);
  return [t.current, loaded];
};

exports.useLocalization = useLocalization;

var LoadLocalizationNamespace = function LoadLocalizationNamespace(_ref) {
  var namespace = _ref.namespace,
      children = _ref.children;

  var _useLocalization = useLocalization(namespace),
      _useLocalization2 = (0, _slicedToArray2.default)(_useLocalization, 2),
      loaded = _useLocalization2[1];

  return loaded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  }) : null;
};

exports.LoadLocalizationNamespace = LoadLocalizationNamespace;